 const slide = document.getElementById('carouselSlide');
        let currentIndex = 0;

        function updateSlide() {
            const width = document.querySelector('.carousel-container').offsetWidth;
            slide.style.transform = `translateX(-${currentIndex * width}px)`;
            console.log(`Current Index: ${currentIndex}, Slide Width: ${width}`);  // Debugging currentIndex and width
        }

        function nextSlide() {
            console.log("Next button clicked");  // Debugging next button click
            if (currentIndex < slide.children.length - 1) {
                currentIndex++;
            } else {
                currentIndex = 0; // Loop back to the first slide
            }
            updateSlide();
        }

        function prevSlide() {
            console.log("Prev button clicked");  // Debugging prev button click
            if (currentIndex > 0) {
                currentIndex--;
            } else {
                currentIndex = slide.children.length - 1; // Loop back to the last slide
            }
            updateSlide();
        }

        window.addEventListener('resize', updateSlide);
        window.onload = updateSlide;
